module.exports = __webpack_public_path__ + "img/soff.495ac38a.jpg";